import { render, staticRenderFns } from "./VersionSelect.vue?vue&type=template&id=b2bb275c&scoped=true"
import script from "./VersionSelect.vue?vue&type=script&lang=js"
export * from "./VersionSelect.vue?vue&type=script&lang=js"
import style0 from "./VersionSelect.vue?vue&type=style&index=0&id=b2bb275c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bb275c",
  null
  
)

export default component.exports